<template>
  <v-row class="admin-list-view-datetime mx-0" align="end">
    <v-col cols="6" class="pa-0">
      <AdminInputDatepicker :timestamp="_timestamp" @input="date = $event" />
    </v-col>
    <v-col cols="6" class="pa-0">
      <AdminInputTimepicker :timestamp="_timestamp" @input="time = $event" />
    </v-col>
  </v-row>
</template>

<script>
import { format, parseISO, parse } from 'date-fns'
import * as TimeFormats from '@/constants/TimeFormats'

import AdminInputDatepicker from '@/components/AdminInputDatepicker'
import AdminInputTimepicker from '@/components/AdminInputTimepicker'
export default {
  name: 'AdminInputDatetime',
  components: {
    AdminInputDatepicker,
    AdminInputTimepicker,
  },
  props: {
    timestamp: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {}
  },
  computed: {
    date: {
      get() {
        return format(parseISO(this.timestamp), TimeFormats.dateDashes)
      },
      set(newDate) {
        this._timestamp = this.updateTimestamp(newDate, this.time)
      },
    },
    time: {
      get() {
        return format(parseISO(this.timestamp), TimeFormats.time12hr)
      },
      set(newTime) {
        this._timestamp = this.updateTimestamp(this.date, newTime)
      },
    },
    _timestamp: {
      get() {
        return this.timestamp
      },
      set($val) {
        this.$emit('update', $val)
      },
    },
  }, // computed
  methods: {
    updateTimestamp(date, time) {
      return format(
        parse(`${date} ${time}`, 'y-MM-dd h:mm aaa', new Date()),
        TimeFormats.dateAndTime
      )
    }, // updateTimestamp
  },
}
</script>

<style lang="scss">
.admin-list-view-datetime .v-input {
  font-size: 0.9rem !important;
}

.admin-list-view-datetime {
  .v-text-field > .v-input__control > .v-input__slot:before {
    display: none;
  }
}
</style>
